import React from "react";
import { Switch, Route } from "react-router-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import Pita from "../pages/pita";
import Pelekatan from "../pages/pelekatan";
import AddPelekatan from "../pages/pelekatan/form";
import EditPelekatan from "../pages/pelekatan/form/edit";
import EditPita from "../pages/pita/form/edit";
import AddPita from "../pages/pita/form";
const PitaRouter = () => {
  return (
    <TransitionGroup>
      <CSSTransition classNames="fadein" timeout={300}>
        <Switch>
          <Route path="/pita/addpita" component={AddPita} />
          <Route path="/pita/edit/:idIncomingPc" component={EditPita} />
          <Route path="/pita/pelekatan" component={Pelekatan} />
          <Route path="/pita/addpelekatan" component={AddPelekatan} />
          <Route
            path="/pita/editpelekatan/:idPelekatanPc"
            component={EditPelekatan}
          />
          <Route path="/pita/browse" component={Pita} />
        </Switch>
      </CSSTransition>
    </TransitionGroup>
  );
};

export default PitaRouter;
